export default {
  en: {
    header: 'Your application has been updated and must be refreshed.',
    btnConfirm: 'Refresh',
  },
};
